module.exports = __webpack_public_path__ + "img/flomaktsomhet.f689c006.jpg";